import { render, staticRenderFns } from "./EditBot.vue?vue&type=template&id=cc05e992"
import script from "./EditBot.vue?vue&type=script&lang=js"
export * from "./EditBot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports